<template>
    <div>
      <div class="tabs">
        <button
          v-for="(tab, index) in tabs"
          :key="index"
          :class="{ active: index === activeTabIndex }"
          @click="activeTabIndex = index"
        >
          {{ tab.title }}
        </button>
      </div>
      <div class="tab-content">
        <slot />
      </div>
    </div>
  </template>
  
  <script>
  import { provide, reactive, toRefs } from 'vue';
  
  export default {
    name: 'Tabs',
    setup() {
      const state = reactive({
        tabs: [],
        activeTabIndex: 0,
      });
  
      const register = (tab) => {
        state.tabs.push(tab);
        return {
          isActive: () => state.tabs.indexOf(tab) === state.activeTabIndex,
          unregister: () => {
            const index = state.tabs.indexOf(tab);
            if (index > -1) state.tabs.splice(index, 1);
          }
        };
      };
  
      provide('tabs-register', register);
      provide('active-tab-index', toRefs(state).activeTabIndex);
  
      return { ...toRefs(state) };
    }
  };
  </script>
  
<style>
.tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    width: 100%;
    max-width: 100%;
    padding: 6px;
    background: #f4f6f9;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    box-sizing: border-box;
}

.tabs button {
    padding: 9px 13px;
    border: none;
    background: transparent;
    color: #6c757d;
    font-size: 14px;
    font-weight: 500;
    border-radius: 6px;
    cursor: pointer;
    transition: 0.2s;
    white-space: normal;
    text-align: center;
    max-width: 100%;
}

.tabs button:hover {
    background: white;
    color: #343a40;
}

.tabs button.active {
    background: #F49315;
    color: white;
    font-weight: 600;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.12);
}

.tab-content {
    margin-top: 20px;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
}


/* =========================
   CELULAR
   ========================= */

@media (max-width: 768px) {

    .tabs {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 5px;
        padding: 5px;
        width: 100%;
    }

    .tabs button {
        width: 100%;
        min-width: 0;
        padding: 9px 6px;
        font-size: 12px;
        line-height: 1.2;
        white-space: normal;
        overflow-wrap: break-word;
    }

    .tab-content {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        overflow-x: hidden;
    }
}


/* =========================
   CELULAR MUY PEQUEÑO
   ========================= */

@media (max-width: 400px) {

    .tabs {
        grid-template-columns: 1fr 1fr;
    }

    .tabs button {
        font-size: 11px;
        padding: 8px 5px;
    }
}
</style>